/* tslint:disable */
/* eslint-disable */
/**
 * My App API
 * My App API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WmdType
 */
export interface WmdType {
    /**
     * 
     * @type {Date}
     * @memberof WmdType
     */
    createdAt: Date;
    /**
     * 
     * @type {number}
     * @memberof WmdType
     */
    version: number;
    /**
     * 
     * @type {Date}
     * @memberof WmdType
     */
    updatedAt: Date;
    /**
     * 
     * @type {number}
     * @memberof WmdType
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof WmdType
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof WmdType
     */
    code: string;
    /**
     * 
     * @type {number}
     * @memberof WmdType
     */
    displayOrder: number;
}

export function WmdTypeFromJSON(json: any): WmdType {
    return WmdTypeFromJSONTyped(json, false);
}

export function WmdTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): WmdType {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'createdAt': (new Date(json['createdAt'])),
        'version': json['version'],
        'updatedAt': (new Date(json['updatedAt'])),
        'id': json['id'],
        'name': json['name'],
        'code': json['code'],
        'displayOrder': json['displayOrder'],
    };
}

export function WmdTypeToJSON(value?: WmdType | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'createdAt': (value.createdAt.toISOString()),
        'version': value.version,
        'updatedAt': (value.updatedAt.toISOString()),
        'id': value.id,
        'name': value.name,
        'code': value.code,
        'displayOrder': value.displayOrder,
    };
}


